module.exports = __webpack_public_path__ + "static/media/happy_ladies_mobile.7d852883.png";